// Zamienia hash na parametr zapytania dla substance URL
export const substanceToUrl = (browserWindow, substance) => {
  return `${browserWindow.location.origin}${browserWindow.location.pathname}?substance=${substance.token}`;
}

// Zamienia hash na parametr zapytania dla substance pathname
export const substanceToPathname = (browserWindow, substance) => {
  return `${browserWindow.location.pathname}?substances=${substance.token}`;
}

// Wyciąga substanceId z parametrów zapytania zamiast hash
export const getSubstanceIdFromUrl = (browserWindow) => {
  let substanceId = null;

  // Sprawdzenie parametrów zapytania
  const urlParams = new URLSearchParams(browserWindow.location.search);
  substanceId = urlParams.get('substances') || urlParams.get('substance');
  
  // Sprawdzenie w ścieżce URL
  const pathName = browserWindow.location.pathname;

  if (substanceId == null) {
    // console.log("Checking for match on pathname", pathName);
    if (/^\/substances\/.+/.test(pathName)) {
      const parts = pathName.split(/\/|\#/);
      const substanceIndex = parts.indexOf("substances");
      if (substanceIndex >= 0 && parts.length >= substanceIndex + 2) {
        substanceId = parts[substanceIndex + 1];
      }
    }
  }

  return substanceId;
}

// Zamienia hash na parametr zapytania dla analyze URL
export const encodedQueriesToUrl = (browserWindow, encodedQueries) => {
  return `${browserWindow.location.origin}${browserWindow.location.pathname}?analyze=${encodedQueries}`;
}

// Zamienia hash na parametr zapytania dla analyze pathname
export const encodedQueriesToPathname = (browserWindow, encodedQueries) => {
  return `${browserWindow.location.pathname}?analyze=${encodedQueries}`;
}

// Wyciąga encodedQueries z parametrów zapytania zamiast hash
export const getEncodedQueriesFromUrl = (browserWindow) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('analyze');
}

// Zamienia hash na parametr zapytania dla search URL
export const searchToUrl = (browserWindow, term) => {
  return `${browserWindow.location.origin}${browserWindow.location.pathname}?search=${term}`;
}

// Zamienia hash na parametr zapytania dla search pathname
export const searchToPathname = (browserWindow, term) => {
  return `${browserWindow.location.pathname}?search=${term}`;
}

// Wyciąga search term z parametrów zapytania zamiast hash
export const getSearchTermFromUrl = (browserWindow) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('search');
}
